import { StyledSvgIcon } from 'app/ui-components/SvgIcon/SvgIcon.styles';
import styled, { css } from 'styled-components';
import { regularWhite, fontWeightBold, iconClose } from '../../../ui-components/design-tokens';
import { playFontIcon } from '../../../ui-components/typography/helpers';
import { playFocus } from '../../../ui-components/utils.styles';
import { device } from '../../../ui-components/breakpoints';

export const StyledToggle = styled.button`
    display: none;
    color: ${regularWhite};
    appearance: none;
    background-color: transparent;
    border: none;
    text-transform: uppercase;
    font-weight: ${fontWeightBold};
    ${playFocus()}
    padding: 5px 0;
    margin-left: auto;
    z-index: 1;

    &:hover {
        span {
            text-decoration: underline;
        }
    }

    @media ${device.GteXsmall} {
        display: flex;
    }

    ${({ displayEpisodePicker }) =>
        displayEpisodePicker &&
        css`
            &:before {
                margin-right: 5px;
                ${playFontIcon(1.5, iconClose)}
            }
        `}

    ${StyledSvgIcon} {
        margin-right: 5px;
        height: 14px;
    }
`;
